import { render } from "./SideMenu.vue?vue&type=template&id=7a6324ab&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=7a6324ab&scoped=true&lang=stylus"

import exportComponent from "D:\\tokyo-shoseki_R7\\07j\\s\\r\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6324ab"]])

export default __exports__